import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import ApplianceForm from '#component/warehouse/appliance-form/form';
import { updateBreadcrumb } from '#action/breadcrumb';
import { fetchWarehouses } from '#action/warehouse/warehouses';
import { createAppliance } from '#action/warehouse/appliance/appliance';
import { putApplianceDevices } from '#action/warehouse/appliance/appliance-devices';
import { clearDevicesAvailable } from '#action/device/device-avaliable';
import PreloaderComponent from '#component/preloader';
import { setDocumentTitle, uuidv4 } from '#helper';

const AddApplianceForm = props => {
  const { match: { params: { warehouseId } }, history } = props;
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const account = useSelector(s => s.account, shallowEqual);
  const { warehouses } = useSelector(s => s.warehouses, shallowEqual);

  const initialValues = useMemo(() => {
    if (warehouseId) {
      const iV = {
        warehouse: warehouses.find(w => w.id === Number(warehouseId)) || warehouseId,
        devicesGroup: [{ id: uuidv4() }]
      };
      return iV;
    }

    return {
      devicesGroup: [{ id: uuidv4() }]
    };
  }, [warehouseId, warehouses]);

  useEffect(() => {
    setDocumentTitle('Add Application');
    dispatch(
      updateBreadcrumb([
        { label: 'Sites', path: '/warehouse' },
        { label: 'Add application' }
      ])
    );
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchWarehouses());
      setLoading(false);
    };

    fetchData();

    return () => {
      dispatch(clearDevicesAvailable());
    };
  }, [dispatch]);

  const handleFormSubmit = async values => {
    const {
      label,
      warehouse,
      devicesGroup
    } = values;

    const data = {
      label,
      warehouseId: +warehouse
    };

    const { id } = await dispatch(createAppliance(data));
    const { success } = await dispatch(putApplianceDevices(id, devicesGroup ?? []));

    if (id && success) {
      history.push(`/warehouse/appliance-overview/${id}`);
    }
    return { success };
  };

  return (
    !loading ? (
      <ApplianceForm
        title="Add new application"
        {...props}
        initialValues={initialValues}
        handleFormSubmit={handleFormSubmit}
        editable={true}
        account={account}
      />
    ) : (
      <PreloaderComponent />
    )
  );
};

export default AddApplianceForm;
